module.exports = __webpack_public_path__ + "img/id-removebg.a8bbd14c.png";